import useMutation from "./useMutation";
import { webHomePath } from "lib/webRoutes";

const { REACT_APP_WEB_URL } = process.env;
const WEB_URL = REACT_APP_WEB_URL || "https://web.qa.drapp.la";

/**
 * Compartido entre NewUiBanner.js y el toggle del menú de cuenta (Navbar.js)
 * — mismo mutation a /features/web-ui, dos lugares desde donde el usuario
 * puede cambiar su propio opt-in a la nueva UI (UI_REFACTOR_PLAN.md §7).
 * Feedback real (@nachoconstenla, 2026-08-26): antes de esto, optar por la
 * nueva UI (o rechazar el banner) era una decisión de un solo sentido — sin
 * el toggle del menú no había forma de volver a cambiar de opinión.
 */
export default function useWebUiToggle(teamId) {
  const [mutate, mutation] = useMutation(window._l("/features/web-ui").substr(1));

  const setWebUi = (enabled) => {
    mutate(
      { enabled },
      {
        onSuccess: () => {
          // Sólo redirige al activar: quien puede desactivarlo ya está
          // viendo drmanager (webUi ya era false, o llegó acá con
          // ?ui=legacy de sesión) — no hay a dónde "volver".
          if (enabled) {
            window.location.href = `${WEB_URL}${webHomePath(teamId)}?ui=next`;
          }
        },
      }
    );
  };

  return { setWebUi, isLoading: mutation.isLoading };
}
